module.exports = "https://portperrypedals.ca/_res/img/oakridges.fe08bb0.png";